import dayjs from "dayjs";
import ShiftsService from "./shiftsService";
import StorePlanningService from "./storePlanningService";
import { getWorker, getSchedule, getShop } from '../getters';

const weekOfYear = require('dayjs/plugin/weekOfYear')
const weekYear = require('dayjs/plugin/weekYear')
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

class ShiftsObjects {

    /**
     * 
     * @param {String} token 
     * @param {Number} year 
     * @param {Number} weekNr 
     * @param {Number} groupId
     * @param {Number} scheduleId
     * @returns Object of a scheduled week
     */

    async getShiftObject(token, year, weekNr, groupId, scheduleId) {
        const allShifts = await ShiftsService.getShifts(token, year, weekNr, groupId)
        var arrayIds = [];
        var storeIds = await StorePlanningService.getShopsIdArray(token, year, weekNr, groupId)
        var shopIds = Array.from(storeIds).filter(id => getShop(id).group_id == groupId)
        var filteredArray = [];

        var scheduling_id = scheduleId

        console.log('lunedì: ', dayjs().week(weekNr).year(year).day(1).format('YYYY-MM-DD'))
        console.log('lunedì: ', dayjs().month(0).year(year).week(1).day(1).format('YYYY-MM-DD'))
        console.log('settimana: ', weekNr)
        console.log('anno: ', year)
        console.log('anno settimana corrente: ', dayjs().day(6).format('YYYY'))

        Array.from(allShifts).map((shift) => {
            if (!arrayIds.includes(shift.shop_id)) {
                    arrayIds.push(shift.shop_id)
                }
        })

        if (shopIds.length > 0) {
            shopIds.map(() => {
                filteredArray.push([])
            })

            Array.from(shopIds).map((shift, index) => {

                var shifts = [];

                var shopsList = JSON.parse(localStorage.getItem('shopsList'))

                var shopName

                Array.from(shopsList).map((item) => {
                    if (item.id == shift) shopName = item.full_name
                })

                for (var x = 0; x < 7; x++) {
                    if(weekNr == 1){
                        var date = dayjs().month(0).year(year).week(weekNr).day(1).add(x, 'day').format('YYYY-MM-DD');
                    }else{
                        date = dayjs().week(weekNr).year(year).day(1).add(x, 'day').format('YYYY-MM-DD');
                    }
                    shifts.push({
                        date: date,
                        morning: {
                            check_in: null,
                            check_out: null,
                            id: null,
                            message: null,
                            shift_id: null,
                            status: null,
                            time_end: null,
                            time_start: null,
                            tot_hours_worked: 0,
                            worker: null,
                        },
                        afternoon: {
                            check_in: null,
                            check_out: null,
                            id: null,
                            message: null,
                            shift_id: null,
                            status: null,
                            time_end: null,
                            time_start: null,
                            tot_hours_worked: 0,
                            worker: null,
                        },
                        evening: {
                            check_in: null,
                            check_out: null,
                            id: null,
                            message: null,
                            shift_id: null,
                            status: null,
                            time_end: null,
                            time_start: null,
                            tot_hours_worked: 0,
                            worker: null,
                        }
                    })

                    filteredArray[index].group_id = groupId
                    filteredArray[index].shop_name = shopName
                    filteredArray[index].shop_id = shift
                    filteredArray[index].scheduling_id = scheduling_id
                    filteredArray[index].shifts = shifts

                }
            })

            Array.from(allShifts).map((shift) => {
                for (var j = 0; j < filteredArray.length; j++) {

                    if (shift.shop_id == filteredArray[j].shop_id) {

                        Array.from(filteredArray[j].shifts).map((currentShift) => {

                            if (currentShift.date == dayjs(shift.date).format('YYYY-MM-DD') && shift.period == 0) {

                                currentShift.morning.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                                currentShift.morning.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                                currentShift.morning.id = shift.user_id
                                currentShift.morning.message = shift.message
                                currentShift.morning.shift_id = shift.id
                                currentShift.morning.status = shift.status
                                currentShift.morning.time_end = shift.time_end.substring(0, 5)
                                currentShift.morning.time_start = shift.time_start.substring(0, 5)
                                currentShift.morning.tot_hours_worked = shift.tot_hours_worked
                                currentShift.morning.worker = shift.user_name
                            }
                            if (currentShift.date == dayjs(shift.date).format('YYYY-MM-DD') && shift.period == 1) {

                                currentShift.afternoon.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                                currentShift.afternoon.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                                currentShift.afternoon.id = shift.user_id
                                currentShift.afternoon.message = shift.message
                                currentShift.afternoon.shift_id = shift.id
                                currentShift.afternoon.status = shift.status
                                currentShift.afternoon.time_end = shift.time_end.substring(0, 5)
                                currentShift.afternoon.time_start = shift.time_start.substring(0, 5)
                                currentShift.afternoon.tot_hours_worked = shift.tot_hours_worked
                                currentShift.afternoon.worker = shift.user_name
                            }
                            if (currentShift.date == dayjs(shift.date).format('YYYY-MM-DD') && shift.period == 2) {

                                currentShift.evening.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                                currentShift.evening.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                                currentShift.evening.id = shift.user_id
                                currentShift.evening.message = shift.message
                                currentShift.evening.shift_id = shift.id
                                currentShift.evening.status = shift.status
                                currentShift.evening.time_end = shift.time_end.substring(0, 5)
                                currentShift.evening.time_start = shift.time_start.substring(0, 5)
                                currentShift.evening.tot_hours_worked = shift.tot_hours_worked
                                currentShift.evening.worker = shift.user_name
                            }
                        })
                    }
                }
            })

            localStorage.setItem('shopsShiftObject', JSON.stringify(filteredArray))
        }

        const comparator = (a, b) => {
            if(a.shop_name < b.shop_name){
                return -1
            }else if(a.shop_name > b.shop_name){
                return 1
            }
            return 0
        }

        filteredArray = filteredArray.sort(comparator)

        console.log('GET SHIFT OBJECT: ', filteredArray)

        return filteredArray;
    }

    /**
     * 
     * @param {Array} shops Shops ids Array 
     * @param {Number} year year
     * @param {Number} weekNr number of the week
     * @param {Number} scheduling_id id of the schedule
     * @returns New shifts Object
     */

    createShiftObject(shops, year, weekNr, scheduling_id) {
        var arrayIds = [];
        var filteredArray = [];

        shops.map((id) => {
            if (!arrayIds.includes(id)) {
                arrayIds.push(id)
            }
        })

        arrayIds.map(() => {
            filteredArray.push([])
        })

        for (var i = 0; i < arrayIds.length; i++) {

            var shopsList = JSON.parse(localStorage.getItem('shopsList'))

            var shopName
            var groupId

            Array.from(shopsList).map((shop) => {
                if (shop.id == arrayIds[i]) {
                    shopName = shop.full_name
                    groupId = shop.group_id
                }
            })

            var shifts = [];

            for (var x = 0; x < 7; x++) {

                if(weekNr == 1){
                    var date = dayjs().month(0).year(year).week(weekNr).day(1).add(x, 'day').format('YYYY-MM-DD');
                }else{
                    date = dayjs().week(weekNr).year(year).day(1).add(x, 'day').format('YYYY-MM-DD');
                }

                shifts.push({
                    date: date,
                    morning: {
                        check_in: null,
                        check_out: null,
                        id: null,
                        message: null,
                        shift_id: null,
                        status: null,
                        time_end: null,
                        time_start: null,
                        tot_hours_worked: 0,
                        worker: null,
                    },
                    afternoon: {
                        check_in: null,
                        check_out: null,
                        id: null,
                        message: null,
                        shift_id: null,
                        status: null,
                        time_end: null,
                        time_start: null,
                        tot_hours_worked: 0,
                        worker: null,
                    },
                    evening: {
                        check_in: null,
                        check_out: null,
                        id: null,
                        message: null,
                        shift_id: null,
                        status: null,
                        time_end: null,
                        time_start: null,
                        tot_hours_worked: 0,
                        worker: null,
                    }
                })

                filteredArray[i] = {
                    shop_id: arrayIds[i],
                    group_id: groupId,
                    shop_name: shopName,
                    scheduling_id: scheduling_id,
                    shifts: shifts
                }

            }
        }

        const comparator = (a, b) => {
            return parseInt(a.group_id) - parseInt(b.group_id);
        }

        filteredArray = filteredArray.sort(comparator)

        console.log('CREATED SHIFT OBJECT: ', filteredArray)

        return filteredArray;
    }

    /**
     * 
     * @param {String} token 
     * @param {Number} year 
     * @param {Number} weekNr 
     * @param {Array} shops Shops ids Array
     * @param {Date} weekDate Date Object of the scheduling week
     * @param {Number} scheduling_id 
     * @returns New updated shifts object
     */

    async updateShiftObject(token, year, weekNr, groupId, shops, scheduling_id) {
        var arrayIds = []
        var existentSchedule = await this.getShiftObject(token, year, weekNr, groupId, scheduling_id)

        Array.from(existentSchedule).map((shift) => {
            arrayIds.push(shift.shop_id)
        })

        shops = Array.from(shops).filter(id => getShop(id).group_id == groupId)

        shops.map((shop) => {

            if (!arrayIds.includes(shop)) {

                var shifts = [];

                var shopsList = JSON.parse(localStorage.getItem('shopsList'))

                var shopName
                var groupId

                Array.from(shopsList).map((item) => {
                    if (item.id == shop) {
                        shopName = item.full_name
                        groupId = item.group_id
                    }
                })

                for (var x = 0; x < 7; x++) {

                    if(weekNr == 1){
                        var date = dayjs().month(0).year(year).week(weekNr).day(1).add(x, 'day').format('YYYY-MM-DD');
                    }else{
                        date = dayjs().week(weekNr).year(year).day(1).add(x, 'day').format('YYYY-MM-DD');
                    }
                    
                    shifts.push({
                        date: date,
                        morning: {
                            check_in: null,
                            check_out: null,
                            id: null,
                            message: null,
                            shift_id: null,
                            status: null,
                            time_end: null,
                            time_start: null,
                            tot_hours_worked: 0,
                            worker: null,
                        },
                        afternoon: {
                            check_in: null,
                            check_out: null,
                            id: null,
                            message: null,
                            shift_id: null,
                            status: null,
                            time_end: null,
                            time_start: null,
                            tot_hours_worked: 0,
                            worker: null,
                        },
                        evening: {
                            check_in: null,
                            check_out: null,
                            id: null,
                            message: null,
                            shift_id: null,
                            status: null,
                            time_end: null,
                            time_start: null,
                            tot_hours_worked: 0,
                            worker: null,
                        }
                    })

                    var newShift = {
                        shop_id: shop,
                        group_id: groupId,
                        shop_name: shopName,
                        scheduling_id: scheduling_id,
                        shifts: shifts
                    }

                }

                existentSchedule.push(newShift)
            }
        })

        const comparator = (a, b) => {
            if(a.shop_id < b.shop_id){
                return -1
            }else if(a.shop_id > b.shop_id){
                return 1
            }
            return 0
        }

        existentSchedule = existentSchedule.sort(comparator)

        console.log('UPDATED SHIFT OBJECT: ', existentSchedule)

        return existentSchedule.sort(comparator)

    }

    /**
     * 
     * @param {String} token 
     * @param {Number} year 
     * @param {Number} weekNr 
     * @returns Object of a scheduled week with workers as keys
     */

    async getShiftObjectByWorker(token, year, weekNr) {

        const allShifts = await ShiftsService.getShiftsAllWeek(token, year, weekNr)
        var arrayIds = [];
        var arrayDates = [];
        var filteredArray = [];

        Array.from(allShifts).map((shift) => {

            if (!arrayIds.includes(shift.user_id)) {
                arrayIds.push(shift.user_id)
            }
            if (!arrayDates.includes(arrayDates[i])) {
                arrayDates.push(shift.date)
            }
        })

        arrayIds.map(() => {
            filteredArray.push([])
        })

        for (var i = 0; i < allShifts.length; i++) {

            Array.from(allShifts).map((shift) => {

                if (shift.user_id == arrayIds[i]) {
                    var shifts = [];
                    for (var x = 0; x < 7; x++) {

                        if(weekNr == 1){
                            var date = dayjs().month(0).year(year).week(weekNr).day(1).add(x, 'day').format('DD-MM-YYYY');
                        }else{
                            date = dayjs().week(weekNr).year(year).day(1).add(x, 'day').format('DD-MM-YYYY');
                        }

                        shifts.push({
                            date: date,
                            morning: {
                                check_in: null,
                                check_out: null,
                                id: null,
                                message: null,
                                shift_id: null,
                                status: null,
                                time_end: null,
                                time_start: null,
                                tot_hours_worked: 0,
                                worker: null,
                            },
                            afternoon: {
                                check_in: null,
                                check_out: null,
                                id: null,
                                message: null,
                                shift_id: null,
                                status: null,
                                time_end: null,
                                time_start: null,
                                tot_hours_worked: 0,
                                worker: null,
                            },
                            evening: {
                                check_in: null,
                                check_out: null,
                                id: null,
                                message: null,
                                shift_id: null,
                                status: null,
                                time_end: null,
                                time_start: null,
                                tot_hours_worked: 0,
                                worker: null,
                            }
                        })

                        filteredArray[i].shop_name = shift.user_name
                        filteredArray[i].shop_id = shift.user_id
                        filteredArray[i].last_name = getWorker(shift.user_id).surname
                        filteredArray[i].shifts = shifts
                    }
                }
            })
        }

        Array.from(allShifts).map((shift) => {

            for (var j = 0; j < filteredArray.length; j++) {

                if (shift.user_name == filteredArray[j].shop_name) {

                    Array.from(filteredArray[j].shifts).map((currentShift) => {

                        if (currentShift.date == dayjs(shift.date).format('DD-MM-YYYY') && shift.period == 0) {

                            currentShift.morning.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                            currentShift.morning.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                            currentShift.morning.id = shift.shop_id
                            currentShift.morning.message = shift.message
                            currentShift.morning.shift_id = shift.id
                            currentShift.morning.status = shift.status
                            currentShift.morning.time_end = shift.time_end.substring(0, 5)
                            currentShift.morning.time_start = shift.time_start.substring(0, 5)
                            currentShift.morning.tot_hours_worked = shift.tot_hours_worked
                            currentShift.morning.worker = shift.shop_name
                        }
                        if (currentShift.date == dayjs(shift.date).format('DD-MM-YYYY') && shift.period == 1) {

                            currentShift.afternoon.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                            currentShift.afternoon.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                            currentShift.afternoon.id = shift.shop_id
                            currentShift.afternoon.message = shift.message
                            currentShift.afternoon.shift_id = shift.id
                            currentShift.afternoon.status = shift.status
                            currentShift.afternoon.time_end = shift.time_end.substring(0, 5)
                            currentShift.afternoon.time_start = shift.time_start.substring(0, 5)
                            currentShift.afternoon.tot_hours_worked = shift.tot_hours_worked
                            currentShift.afternoon.worker = shift.shop_name
                        }
                        if (currentShift.date == dayjs(shift.date).format('DD-MM-YYYY') && shift.period == 2) {

                            currentShift.evening.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                            currentShift.evening.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                            currentShift.evening.id = shift.shop_id
                            currentShift.evening.message = shift.message
                            currentShift.evening.shift_id = shift.id
                            currentShift.evening.status = shift.status
                            currentShift.evening.time_end = shift.time_end.substring(0, 5)
                            currentShift.evening.time_start = shift.time_start.substring(0, 5)
                            currentShift.evening.tot_hours_worked = shift.tot_hours_worked
                            currentShift.evening.worker = shift.shop_name
                        }
                    })
                }
            }
        })

        const comparator = (a, b) => {
            if(a.last_name < b.last_name){
                return -1
            }else if(a.last_name > b.last_name){
                return 1
            }
            return 0
        }

        filteredArray = filteredArray.sort(comparator)
        localStorage.setItem('workersShiftObject', JSON.stringify(filteredArray))
        console.log('SHIFT OBJECT BY WORKERS: ', filteredArray)
        return filteredArray;
    }

    /**
     * 
     * @param {String} token 
     * @param {Number} year 
     * @param {Number} weekNr 
     * @param {Number} worker Worker id
     * @returns Object of a scheduled week with one worker a key
     */

    async getShiftObjectBySingleWorker(token, year, weekNr, worker) {

        const allShifts = await ShiftsService.getShiftsAllWeek(token, year, weekNr)
        var filteredArray = [];
        var newShift;

            Array.from(allShifts).map((shift) => {

                if (shift.user_id == worker) {

                    var shifts = [];
                    for (var x = 0; x < 7; x++) {

                        if(weekNr == 1){
                            var date = dayjs().month(0).year(year).week(weekNr).day(1).add(x, 'day').format('DD-MM-YYYY');
                        }else{
                            date = dayjs().week(weekNr).year(year).day(1).add(x, 'day').format('DD-MM-YYYY');
                        }

                        shifts.push({
                            date: date,
                            morning: {
                                check_in: null,
                                check_out: null,
                                id: null,
                                message: null,
                                shift_id: null,
                                status: null,
                                time_end: null,
                                time_start: null,
                                tot_hours_worked: 0,
                                worker: null,
                            },
                            afternoon: {
                                check_in: null,
                                check_out: null,
                                id: null,
                                message: null,
                                shift_id: null,
                                status: null,
                                time_end: null,
                                time_start: null,
                                tot_hours_worked: 0,
                                worker: null,
                            },
                            evening: {
                                check_in: null,
                                check_out: null,
                                id: null,
                                message: null,
                                shift_id: null,
                                status: null,
                                time_end: null,
                                time_start: null,
                                tot_hours_worked: 0,
                                worker: null,
                            }
                        })

                        newShift = {
                            shop_name : getWorker(worker).full_name,
                            shop_id : shift.user_id,
                            scheduling_id : shift.scheduling_id,
                            shifts : shifts
                        }
                    }
                }
            })

        filteredArray.push(newShift)

        Array.from(allShifts).map( async (shift) => {

            const singleSchedule = getSchedule(shift.scheduling_id)

            for (var j = 0; j < filteredArray.length; j++) {

                if (shift.user_id == worker) {

                    var shiftsNumber = 0

                    Array.from(filteredArray[j].shifts).map((currentShift) => {

                        if(currentShift.date == dayjs(shift.date).format('DD-MM-YYYY')){

                            var counter = 0

                            if (shift.period == 0) {

                                if(singleSchedule && (singleSchedule.week_status == 'in corso' || singleSchedule.week_status == 'pianificato')){

                                    counter += 1
                                    currentShift.morning.visible = true
                                }else{

                                    counter += 0
                                    currentShift.morning.visible = false
                                }
    
                                currentShift.morning.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                                currentShift.morning.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                                currentShift.morning.id = shift.shop_id
                                currentShift.morning.message = shift.message
                                currentShift.morning.shift_id = shift.id
                                currentShift.morning.status = shift.status
                                currentShift.morning.time_end = shift.time_end.substring(0, 5)
                                currentShift.morning.time_start = shift.time_start.substring(0, 5)
                                currentShift.morning.tot_hours_worked = shift.tot_hours_worked
                                currentShift.morning.worker = shift.shop_name
                            }
                            if (shift.period == 1) {

                                if(singleSchedule && (singleSchedule.week_status == 'in corso' || singleSchedule.week_status == 'pianificato')){

                                    counter += 1
                                    currentShift.afternoon.visible = true
                                }else{

                                    counter += 0
                                    currentShift.afternoon.visible = false
                                }
    
                                currentShift.afternoon.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                                currentShift.afternoon.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                                currentShift.afternoon.id = shift.shop_id
                                currentShift.afternoon.message = shift.message
                                currentShift.afternoon.shift_id = shift.id
                                currentShift.afternoon.status = shift.status
                                currentShift.afternoon.time_end = shift.time_end.substring(0, 5)
                                currentShift.afternoon.time_start = shift.time_start.substring(0, 5)
                                currentShift.afternoon.tot_hours_worked = shift.tot_hours_worked
                                currentShift.afternoon.worker = shift.shop_name
                            }
                            if (shift.period == 2) {

                                if(singleSchedule && (singleSchedule.week_status == 'in corso' || singleSchedule.week_status == 'pianificato')){

                                    counter += 1
                                    currentShift.evening.visible = true
                                }else{

                                    counter += 0
                                    currentShift.evening.visible = false
                                }
    
                                currentShift.evening.check_in = (shift.check_in !== null) ? shift.check_in.substring(0, 5) : null
                                currentShift.evening.check_out = (shift.check_out !== null) ? shift.check_out.substring(0, 5) : null
                                currentShift.evening.id = shift.shop_id
                                currentShift.evening.message = shift.message
                                currentShift.evening.shift_id = shift.id
                                currentShift.evening.status = shift.status
                                currentShift.evening.time_end = shift.time_end.substring(0, 5)
                                currentShift.evening.time_start = shift.time_start.substring(0, 5)
                                currentShift.evening.tot_hours_worked = shift.tot_hours_worked
                                currentShift.evening.worker = shift.shop_name
                            }

                            shiftsNumber = counter
                        }

                    })

                    filteredArray[j].shifts_number = shiftsNumber
                }
            }
        })

        localStorage.setItem('workersShiftObject', JSON.stringify(filteredArray))
        console.log('SHIFT OBJECT BY SINGLE WORKER: ', filteredArray)
        if(filteredArray.length < 1){
            return {
                shop_name : getWorker(worker).full_name,
                shop_id : null,
                scheduling_id : null,
                shifts : null
            }
        }else{
            return filteredArray[0]
        }
    }

}

export default new ShiftsObjects();